<script  setup>


import {reactive, ref} from "vue";
import {ElCol, ElDatePicker, ElLoading, ElMessage, ElRow} from "element-plus";
import {
    Delete
} from '@element-plus/icons-vue'
import axios from "axios";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';


const props = defineProps({
    hdata:Object,

});


const data=props.hdata;

const ruleFormRef = ref();

const rules = reactive({
    tripid: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    date: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    destination: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    duration: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    guestname: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    guestphone: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    pax: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    arrrivaldetails: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
    departuredetails: [
        {required: true, message: 'Required', trigger: ['blur', 'change']}
    ],
});

const addform=reactive(
    data
)

const ratings=[5,4,3,2,1];

const adddayservice=(index)=>{
    addform.itenaries[index].services.push({ "desc": "",  "info": "", "remarks": "" });
}

const deleteroom=(index,index1)=>{
    addform.itenaries[index].services.splice(index1, 1);
}

const addday=()=>{
    addform.itenaries.push({ "date": "", "services":  []  } );
}
const removeday=(index)=>{
    addform.itenaries.splice(index, 1);
}


const generating=ref(false);

const dialogVisible = ref(false)
const pdfUrl = ref('')

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate(async (valid, fields) => {

        if (valid) {
            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            try {
                const response = await axios.post('/enquiry/vouchers/landvoucherpreview', addform, {
                    responseType: 'blob'
                })
                loading.close()

                const blob = new Blob([response.data], {type: 'application/pdf'})
                pdfUrl.value = URL.createObjectURL(blob)
                dialogVisible.value = true
            } catch (error) {
                loading.close()
            }



        }
    })
}

</script>

<template>


        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{data.enquiry_id}}</a>

                </li>


            </ul>
            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">


                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+data.encryptedid" role="button">BACK</a>
                </li>


            </ul>

        </nav>


    <el-main>
        <el-row :gutter="10">
            <el-col class="pr-w100 text-right" :span="24">
                <el-button type="primary" size="default"  @click="addday()">Add Day</el-button>
               <el-button class="ml-3" type="primary" size="default"  @click="submitForm(ruleFormRef)" :disabled="generating" :loading="generating">Generate Voucher</el-button>

            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col class="pr-w100" :span="24">
                <el-form
                    ref="ruleFormRef"
                    :model="addform"
                    status-icon
                    label-width="auto"
                    class="demo-ruleForm"
                    label-position="top"
                    size="small"
                    :rules="rules"

                >
                    <el-card class="mt-4">
                        <el-row :gutter="10">
                            <el-col class="" :span="2">
                                <el-form-item label="Trip ID" :prop="'tripid'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.tripid"  placeholder="Trip ID" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="3">
                                <el-form-item label="Start Date" :prop="'date'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-date-picker type="date" v-model="addform.date"  placeholder="Date"  format="DD-MMM-YYYY"
                                                    value-format="YYYY-MM-DD" />

                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="5">
                                <el-form-item label="Destination" :prop="'destination'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.destination"  placeholder="Destination" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="3">
                                <el-form-item label="Trip Duration" :prop="'duration'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.duration"  placeholder="Trip Duration" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="3">
                                <el-form-item label="Guest Name" :prop="'guestname'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.guestname"  placeholder="Guest Name" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="3">
                                <el-form-item label="Guest Phone" :prop="'guestphone'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.guestphone"  placeholder="Guest Phone" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="5">
                                <el-form-item label="Pax" :prop="'pax'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.pax"  placeholder="Pax" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="12">
                                <el-form-item label="Arrival Details" :prop="'arrrivaldetails'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.arrrivaldetails"  placeholder="Arrival Details" />
                                </el-form-item>
                            </el-col>
                            <el-col class="" :span="12">
                                <el-form-item label="Departure Details" :prop="'departuredetails'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="addform.departuredetails"  placeholder="Departure Details" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="24"  >
                                <el-form-item label="Helpline" :prop="'helplinenos'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">


                                    <el-select
                                        v-model="addform.helplinenos"
                                        multiple
                                        filterable
                                        allow-create
                                        :reserve-keyword="false"
                                        style="width: 100%"
                                    >

                                    </el-select>
                                </el-form-item>

                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card class="mt-4" v-for="(itninary, index) in addform.itenaries">
                        <el-row :gutter="10">
                            <el-col class="pr-w100 text-right" :span="24">
                                <el-button type="danger" size="small" class="mb-3"  @click="removeday(index)">Remove Day</el-button>

                            </el-col>
                        </el-row>
                        <el-row :gutter="20" >
                            <el-col :span="24" >
                                <el-form-item label="Date" :prop="'itenaries.' + index + '.date'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-date-picker type="date" v-model="itninary.date"  placeholder="Date"  format="DD-MMM-YYYY"
                                                    value-format="YYYY-MM-DD" />
                                </el-form-item>

                            </el-col>

                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="6" >
                                <el-text tag="b" >Services</el-text>
                                <el-button type="primary" size="small" class="ml-4" @click="adddayservice(index)">Add Service</el-button>
                            </el-col>

                        </el-row>
                        <el-row :gutter="20" v-for="(service, index2) in itninary.services">

                            <el-col :span="10" >
                                <el-form-item label="Service Name" :prop="'itenaries.' + index + '.services.'+ index2 + '.desc'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="service.desc" type="textarea" />

                                </el-form-item>

                            </el-col>
                            <el-col :span="10" >
                                <el-form-item label="Remarks" :prop="'itenaries.' + index + '.services.'+ index2 + '.remarks'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="service.remarks" type="textarea" />

                                </el-form-item>

                            </el-col>
                            <el-col :span="3" >
                                <el-form-item label="Info" :prop="'itenaries.' + index + '.services.'+ index2 + '.info'"
                                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                    <el-input v-model="service.info" type="textarea" />

                                </el-form-item>

                            </el-col>

                            <el-col :span="1" >
                                <el-button type="danger" :icon="Delete" circle @click="deleteroom(index,index2)"/>
                            </el-col>
                        </el-row>
                    </el-card>


                    <el-card class="mt-4">
                        <p>
                            <el-text tag="b" size="large">Terms and Conditions</el-text>
                        </p>
                        <quill-editor theme="snow" v-model:content="addform.termandconditions" contentType="html"></quill-editor>
                    </el-card>



                </el-form>

            </el-col>
        </el-row>
    </el-main>
    <el-dialog v-model="dialogVisible" width="80%" title="PDF Preview">
        <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            width="100%"
            height="600px"
            frameborder="0"
        ></iframe>
    </el-dialog>


</template>



<style scoped>

</style>
